import ImageUrlBuilder from '@sanity/image-url';
import { client } from 'app/api/sanity';
import { NextPageContext } from 'next';

export enum Vertical {
	HOTELS = 'hotels',
	FLIGHTS = 'flights',
	CARS = 'cars',
}

const imageUrlBuilder = ImageUrlBuilder(client)

export const getSanityPage = async (ctx: NextPageContext, vertical: Vertical) => {
	const { slug } = ctx.query;
	let lng: string | string[] | undefined = 'en';

	if (ctx.query.hasOwnProperty('lng')) {
		lng = ctx.query.lng;
	}

	const sanityPage = await client.fetch(
		`*[_type == "page" && lng == "${lng}" && slug == "${slug}" && vertical == "${vertical}"][0]`
	);

	return sanityPage;
};

export const getSanityPost = async (ctx: NextPageContext) => {
	const { slug } = ctx.query;
	let lng: string | string[] | undefined = 'en';
	console.log('slug', slug)
	if (ctx.query.hasOwnProperty('lng')) {
		lng = ctx.query.lng;
	}

	const sanityPage = await client.fetch(
		`*[_type == "post" && lng == "${lng}" && slug == "${slug}"][0]`
	);

	return sanityPage;
};

export function getImageUrl(source: string) {
	return imageUrlBuilder.image(source).url();
}


